<gp-modal [closable]="false"
          #createPopup>
  <div class="gp-modal-title">
    {{ 'SETTINGS.user_rights.create_user' | translate }}
  </div>
  <form [formGroup]="userCreateForm" novalidate class="gp-modal-body clearfix">
    <div class="col-md-12">
      <div class="form-group" gpMvel [contractId]="getEmployeeContractId()" [mvelAliases]="mvelAliases">
        <label for="email">{{ 'EMPLOYEE_HIRE.personal_email' | translate }}
          <span class="required"> *</span>
          <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"
             mvel-alias="GP_CREATE_USER_EMAIL"></i>
        </label>
        <div class="input-group">
          <input #emailInput type="text" class="form-control" mvel-alias="recipientEmail" formControlName="email"
                 id="email">
        </div>
        <ul class="error-list"
            [attr.data-hidden]="userCreateForm.valid || userCreateForm.pristine">
          <li *ngIf="this.userCreateForm.get('email').hasError('invalidEmailAddress')">
            {{ 'FORMS.VALIDATORS.invalid_email' | translate }}
          </li>
          <li *ngIf="isEmployee && this.userCreateForm.get('email').hasError('emailExists')">
            {{ 'FORMS.VALIDATORS.email_exists_for_employee_within_company' | translate }}
          </li>
          <li *ngIf="!isEmployee && this.userCreateForm.get('email').hasError('emailExists')">
            {{ 'FORMS.VALIDATORS.email_exists_for_user' | translate }}
          </li>
        </ul>
      </div>
      <div class="form-group col-md-12 no-padding">
        <label class="checkbox">
          <input formControlName="isActivateOnce" type="checkbox" checked>
          {{ 'SETTINGS.user_rights.activate_once' | translate }}
        </label>
      </div>
      <div *ngIf="loading" class="gp-modal-footer">
        <div class="pull-left">
          <i class="fa fa-light fa-spinner fa-spin" aria-hidden="true"></i>
        </div>
      </div>

    </div>
  </form>
  <div class="gp-modal-footer">

    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button type="submit"
                class="btn btn-dark p-x-md"
                (click)="submit()"
                [disabled]="userCreateForm?.invalid || emailValidation">
          {{ 'EMPLOYEE_FORM.submit' | translate }}
        </button>
        <button type="button"
                class="btn btn-secondary p-x-md"
                (click)="createPopup.close()">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>

  </div>
</gp-modal>
